/* eslint-disable import/no-unresolved */
import { MatxLoadable } from "matx";

const CreateDriver = MatxLoadable({
  loader: () => import("../views/drivers/index"),
});

const DriverDetail = MatxLoadable({
  loader: () => import("../views/drivers/driverDetail"),
});

const CorporateDrivers = MatxLoadable({
  loader: () => import("../views/corporate/pendingDrivers"),
});

const GrayBlackView = MatxLoadable({
  loader: () => import("../views/drivers/grayBlackList"),
});

const driverRoutes = [
  {
    path: "/driver/list/:id",
    component: DriverDetail,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/driver/list",
    component: CreateDriver,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/grayBlackList/list",
    component: GrayBlackView,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/corporateDrivers/list",
    component: CorporateDrivers,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default driverRoutes;
